module.exports = __webpack_public_path__ + "static/media/YF05_1.1f4a8216.jpg";